module.exports = __webpack_public_path__ + "img/24.d39c0870.jpg";